<template>
  <div class="flex items-center justify-center gap-x-1 w-full h-full uppercase">
    <img
      :src="asset('images/scan.svg')"
      width="17"
    />
    / Qty
  </div>
</template>

<script setup></script>
